import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { GiftCategoryEdit } from './types'
import { $params } from '../../../../features/router'

export const giftCategoryMounted = createEvent()
export const setGiftCategory = createEvent<GiftCategoryEdit>()
export const submitEditGiftCategory = createEvent<GiftCategoryEdit>()
export const $giftCategory = restore(setGiftCategory, {
  id: 0,
  name: '',
  title: '',
  description: '',
  isShow: false,
  sorting: 0,
})

export const getGiftCategory = fx<void, GiftCategoryEdit>({
  method: 'GET',
  url: '/giftshop/gift_category',
})

export const updateGiftCategory = fx<GiftCategoryEdit, GiftCategoryEdit>({
  method: 'PUT',
  url: '/giftshop/gift_category',
})

sample({
  clock: giftCategoryMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.giftCategoryID
    }
    return {
      url: `/giftshop/gift_category/${id}`,
    }
  },
  target: getGiftCategory,
})

sample({
  clock: [getGiftCategory.doneData, updateGiftCategory.doneData],
  fn: (doneData) => doneData.body,
  target: [setGiftCategory],
})

sample({
  clock: submitEditGiftCategory,
  source: $params,
  fn: (params, giftCategory) => {
    let id
    if (params) {
      id = params.giftCategoryID
    }
    return {
      url: `/giftshop/gift_category/${id}`,
      body: { ...giftCategory },
    }
  },
  target: updateGiftCategory,
})
